import { render, staticRenderFns } from "./TwDropDownTsv.vue?vue&type=template&id=6ff70388&scoped=true&"
import script from "./TwDropDownTsv.vue?vue&type=script&lang=js&"
export * from "./TwDropDownTsv.vue?vue&type=script&lang=js&"
import style0 from "./TwDropDownTsv.vue?vue&type=style&index=0&id=6ff70388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff70388",
  null
  
)

export default component.exports